/*
 * @Author: Huangjs
 * @Date: 2021-03-17 16:23:00
 * @LastEditors: Huangjs
 * @LastEditTime: 2021-12-07 15:18:30
 * @Description: 默认HeatMap构造器
 */

import generateHeatMap from './generate';

const HeatMap = generateHeatMap();

export default HeatMap;
